<template>
  <div>
    <el-input
        v-model="tempModel"
        autocomplete="off"
        placeholder="请选择人员"
        :disabled="disabled == null? false:disabled"
        @focus="openPerson"
        @click="openPerson"
    ></el-input>
    <!-- 人员列表弹窗 -->
    <el-drawer v-model="dialogFormVisiblePerson" title="人员列表" size="45%" append-to-body destroy-on-close>
      <div class="all">
        <div class="center-left">
          <div class="" style="display:flex;justify-content: space-between;margin-bottom: 12px;">
            <el-input v-model="name" placeholder="人员名称"/>
            <el-button class="theBtn" style="margin-left:8px" type="primary" @click="getStaffAll">查询</el-button>
            <el-button class="theBtn"  style="margin-left:8px" type="primary" @click="resetQuery">重置</el-button>
          </div>
          <el-tree
              style="width:100%; color: #000"
              ref="tree"
              :default-expanded-keys="defaultKey"
              default-expand-all
              class="tree"
              highlight-current:true
              :data="dataTree"
              node-key="id"
              :props="defaultProps"
              @node-click="handleNodeClick"
          >
            <template #default="{ node, data }">
          <span class="custom-tree-node">
            <span
                style="color: #000;font-size: 16px;"
                :style="{ fontSize: node.label === enterName ? '16px' : '' }"
            >{{ node.label }} ({{ data.number }})</span
            >
          </span>
            </template>
          </el-tree>
        </div>

        <div style="width:48%;">

          <el-table
          :data="tableDataPerson"
          style="width: 100%; margin-left: 2.5%; background-color: #e9eef3"
          v-fit-columns
          ref="MultiplePerson"
          border
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="name" label="人员姓名" width="" />
      </el-table>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import {getDepartmentTree, getStaffAll} from "../../../request/BasicDataApi";

export default {
  name: "single select",

  data() {
    return {
      name: '',//
      list: [],
      tableDataPerson: [],
      defaultKey: [], //默认打开的树节点
      dialogFormVisiblePerson: false,//人员弹窗
      tempPlaceholder: '请选择人员',
      tempModel: null,
      enterName: sessionStorage.getItem("enterName"),
      dataTree: [], //部门树集合
      defaultProps: {
        //tree格式
        children: "children",
        label: "label",
        number: "number",
        id: "id",
      },
    }
  },
  props: [
    'model', 'disabled', 'placeholder','choosenone'
  ],
  created() {
    getDepartmentTree().then((res) => {
      this.defaultKey = [];
      // if(res.data) {
      //   this.defaultKey.push(res.data[0].id);
      //   this.defaultKey.push(res.data[0].children[0].id);
      // }
      this.dataTree = JSON.parse(JSON.stringify(res.data));
    });

    getStaffAll({
      departId: '',
      name: this.name,
      phone: '',
      sex: '',
      jobSitu: '',
      pageNum: 1, pageSize: 1000
    }).then((res) => {
      if (res.code == 0) {
        let tableDataPerson = res.data.records;
        if(this.choosenone){
          this.tableDataPerson = [ ...tableDataPerson];
        }else{
          this.tableDataPerson = [ ...tableDataPerson];
        }
      }
    });
    if (this.placeholder != null) {
      this.tempPlaceholder = this.placeholder
    }
    this.tempModel = this.model
  },
  methods: {
    //根据部门ID获取部门人员
    handleNodeClick(e) {
      this.current = e.id;
      this.departId = e.id; //选择的部门ID
      if (e.label == this.enterName) {
        this.departId = "";
      }
      this.getStaffAll();
    },
    getStaffAll() {
      getStaffAll({
        departId: this.departId,
        name: this.name,
        phone: '',
        sex: '',
        jobSitu: '',
        pageNum: 1, pageSize: 1000
      }).then((res) => {
        if (res.code == 0) {
          let tableDataPerson = res.data.records;
          if(this.choosenone){
            this.tableDataPerson = [...tableDataPerson];
          }else{
            this.tableDataPerson = [ ...tableDataPerson];
          }
        }
      });
    },
    resetQuery(){
      this.departId = null
      this.name = null
      this.getStaffAll()
    },
    //选择责任人
    handleCurrentChange(e) {
      this.dialogFormVisiblePerson = false;
      this.$emit('id', e.id)
      this.$emit('name', e.name)
      this.$emit('jobNumber', e.jobNumber)
      this.$emit('postId', e.postId)
      this.$emit('postName', e.postName)
      this.$emit('departId', e.departId)
      this.$emit('departName', e.departName)
      this.$emit('event', e)
    },
    //打开人员列表弹窗
    openPerson() {
      this.dialogFormVisiblePerson = true;
    },
    handleSelectionChange(val) {
      if (this.dialogFormVisiblePerson) {
        let idArr = [];
        let nameArr = [];
        val.forEach((item) => {
          idArr.push(item.id);
          nameArr.push(item.name);
        });
        this.$emit("id", idArr.join(","));
        this.$emit("name", nameArr.join(","));
      }
    },
  }, watch: {
    'dialogFormVisiblePerson'(e) {
      // if(!e)this.
    },
    'model'(e) {
      console.log(e)
      this.tempModel = e
    },
  }


}
</script>

<style scoped lang="less">
.all {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .center-left {
    width: 48%;
    height: 79.5vh;
    overflow: auto;
    border-radius: 2px;
  }
}
</style>
